<template>
    <div class="container">
        <div class="content" v-loading="loading">
            <el-tabs v-model="groupId" @tab-click="toggleTabs" class="custom-tabs2">
                <el-tab-pane v-for="(item, index) of tabsList" :label="item.name" :name="item.value" :key="index"></el-tab-pane>
            </el-tabs>
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">数据列表</div>
                </div>
                <div class="title-btn">
                    <div class="title-btn-item" @click="add">
                        <i class="el-icon-plus"></i>
                        <div class="btn-l">新增审批表</div>
                    </div>
                </div>
            </div>
            <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.pageNo" :page-size="page.pageSize" @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
            </lb-table>
        </div>
        <!-- 浮层 -->
        <move-group ref="MoveGroup" @success="fetchData()"></move-group>
        <el-dialog
            title="提示"
            :visible.sync="changeDialog"
            width="30%"
            :append-to-body="true"
            center>
            <span>是否确认{{ currentItem.isStop?'启用':'停用' }}？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="changeDialog = false">取 消</el-button>
                <el-button type="primary" @click="onChangeStatus" :loading="btnStopLoading">确 定</el-button>
            </span>
        </el-dialog>
        <org-picker title="选择对象" multiple ref="orgPicker" @ok="selected"></org-picker>
    </div>
</template>
<script>
import LbTable from '@/components/lb-table/lb-table'
import MoveGroup from "@/pages/officeApproval/components/ManageDialog/moveGroup.vue";
import OrgPicker from "@/components/OrgPicker";
export default {
    name: 'approvalManagement',
    components: {
        LbTable, MoveGroup,OrgPicker
    },
    data() {
        return {
            tabsList: [],
            parArray: [],
            groupId: '',
            page: {
                pageNo: 1,
                pageSize: 10
            },
            isLastPage:false,
            list: [],
            totalNum: 0,
            loading: false,
            currentItem:{},
            changeDialog:false,
            columns: [
                { label: '排序', type:"index", width: '60' },
                { label: '审批单名称', prop: 'templateName', width: '120', align:'left' },
                { label: '审批说明', prop: 'remark', minWidth: '160', align:'left',
                    render: (h, scope) => {
                        return (
                            <div class="ellipsis2">
                                { scope.row.remark }
                            </div>
                        )
                    }
                 },
                { label: '可见范围', prop: 'whoCommit', minWidth: '160',
                 render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:space-between;align-items: center;">
                                <div class="ellipsis2" style="line-height:22px">
                                    { this.personName(scope.row.whoCommit) }
                                </div>
                                <div  onClick={() => { this.onSelectUser(scope.row) }}  style="font-size: 14px;color: #00B498;width: 40px;height: 24px;background: #FFFFFF;border-radius: 2px;border: 1px solid #00B498; cursor:pointer;flex-shrink:0;margin-left:4px">修改</div>
                            </div>
                        )
                    }
                 },
                { label: '最后更新',  width: '160', align:'left',
                    render: (h, scope) => {
                        return (
                            <div style="text-align:left">
                               {scope.row.updatedName}<br/>{scope.row.updatedTime}
                            </div>
                        )
                    }
                },
                {
                    label: '操作', prop: 'orgName', width: '300', fixed: 'right', align: 'center',
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:flex-start">
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookList(scope.row) }} >数据</div>
                                <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.toEdit(scope.row) }} >查看/编辑</div>
                                {
                                    !scope.row.isStop ? <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.moveGroup(scope.row) }} >移动到</div> : ''
                                }
                                {
                                    scope.row.isStop ? <div style="color:red;cursor:pointer;margin-right:8px" onClick={() => { this.changeStatus(scope.row) }} >启用</div> : <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.changeStatus(scope.row) }} >停用</div>
                                }
                                {
                                    this.page.pageNo >1 || scope.$index !== 0 ? <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.onMove('up',scope.row) }} >上移</div> : ''
                                }
                                {
                                    !this.isLastPage || scope.$index !== (this.list.length -1) ? <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.onMove('down',scope.row) }} >下移</div> : ''
                                }
                            </div>
                        )
                    }
                },
            ],
            select:[],
            btnStopLoading:false
        }
    },
    created() {
        
        // 权限设定判断 normsCode
        this.limits = JSON.parse(sessionStorage.getItem("limit"))
        const params = this.limits.buttonTreeDto.find(
            (item) => item.menuCode === "roster"
        )
        params.buttonList.forEach((item) => {
            this.parArray.push(item.code)
        })
    },
    activated() {
        this.fetchGroups()
    },
    mounted() {

    },
    methods: {
        toggleTabs(tab) {
            this.page.pageNo = 1
            this.list = []
              console.log(tab.name);
              if(tab.name<9999){
                this.fetchData()
              }else{
                this.fetchData('disable')
              }
        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        add() {
            // this.$store.commit("setTemplate", this.getTemplateData());
            this.$store.commit("setIsEdit", false);
            this.$router.push({ path: '/officeApproval/approvalManagement/addApproval' })
        },
        getTemplateData(data, group) {
            return data
        },
        onSelectUser(row) {
            // console.log('>>',row)
            this.currentId = row.id
            this.currentProcess = JSON.parse(row.process)
            let whoCommit = row.whoCommit
            let select = []
            if(whoCommit){
                select = JSON.parse(whoCommit)
            }
            this.$refs.orgPicker.show(select)
        },
        selected(selected){
            // console.log('selected>>',selected,this.loading)
            if (this.loading) return false
            let whoCommit = null
            let process = null
            if(selected){
                whoCommit = JSON.stringify(selected)
                 // 修改的的时候需要把process.props.assignedUser 一起改,whoCommit等于assignedUser
                process = this.currentProcess
                process.props.assignedUser = selected
                process = JSON.stringify(process)
            }
            let postData = {
                id: this.currentId,
                whoCommit,
                process
            }
            // console.log('>>', postData)
            this.loading = true
            this.$api.workflowUpdate(postData).then(res => {
                if (res.code == 0) {
                    this.$message.success("可见范围已修改")
                    this.fetchData()
                } else {
                    this.loading = false
                    this.$message.error(res.message)
                }
            }).catch(err => {
                this.loading = false
                this.$message.error(err)
            })
        },
        // 可见范围
        personName(item){
            if(!item) return ''
            let obj  = JSON.parse(item)
            let text = obj.map(item => item.name).join('、') || '全部可见'
            return text
        },
        toEdit(item) {
            this.$store.commit("setIsEdit", true);
            this.$router.push({ path: '/officeApproval/approvalManagement/editApproval',query:{id:item.id,groupId:item.groupId} })
         },
        // 移动
        moveGroup(item) {
            let tabList
            // 裁切数组最后一个对象“已停用”
            if (this.tabsList.length > 1) {
                tabList = this.tabsList.slice(0,-1)
            }
            this.$refs.MoveGroup.show(item, tabList)
        },
        // 停用启用
        changeStatus(item) {
            this.currentItem = item
            this.changeDialog = true
            console.log('>>', item, this.list.length)
        },
        onChangeStatus(){
            if (this.btnStopLoading) return false
            this.btnStopLoading = true
            this.$api.workflowStatus({
                id: this.currentItem.id,
                isStop: !this.currentItem.isStop
            }).then(res => {
                if (res.code == 0) {
                    this.$message.success('操作成功')
                    this.changeDialog = false
                    this.page.pageNo = 1
                    this.list = []
                    this.fetchData()
                } else {
                    this.$message.error(res.message)
                }
                this.btnStopLoading = false
            }).catch(err=>{
                console.log(err)
                this.btnStopLoading = false
            })
        },
        // 移动位置
        onMove(type,item) {
            let apiUrl
            if(type==='down'){
                apiUrl = 'workflowMoveDown'
            }else if(type==='up'){
                apiUrl = 'workflowMoveUp'
            }
            const postData = {
                id: item.id,
            }
            this.loading = true
            this.$api[apiUrl](postData).then((res) => {
                if (res.code == 0) {
                    this.fetchData()
                } else {
                    this.$message.error(res.message)
                    this.loading = false
                }
            }).catch(error => {
                this.loading = false
            })
        },

        // 部门分组列表
        fetchGroups() {
            this.$api.workflowGroups().then((res) => {
                if (res.code == 0) {
                    let list = res.data || []
                    if (list.length > 0) {
                        list.forEach((item) => {
                            item.value = String(item.id)
                        })
                        this.tabsList = list
                        this.tabsList.push({
                            id:9999,
                            sortNum:9999,
                            name: '已停用',
                            value: '9999'
                        })
                        this.groupId = this.tabsList[0].value
                        this.fetchData()
                    }
                    // console.log(this.tabsList)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        fetchData(type) {
            this.loading = true
            if (type == 'reset') {
                this.groupId = this.tabsList[0].value
                this.page.pageNo = 1
            }
            const postData = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize
            }
            let apiUrl
            if (this.groupId>= 999) {
                apiUrl = 'workflowTemplateStopList'
            }else{
                apiUrl = 'workflowTemplateList'
                postData.groupId = this.groupId
            }
            this.$api[apiUrl](postData).then((res) => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.totalNum = res.data.totalNum
                    this.isLastPage =  res.data.pageNo >=   res.data.totalPage
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        },
        // 查看数据
        lookList(item){
            // 修改导航
            localStorage.setItem('selectedMenuIndex', '/officeApproval/approvalAllList')
            this.$router.push({ name: 'approvalAllList',query:{formId:String(item.id)} })
        }
    }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;
     /deep/ .el-table {
         th>.cell {
            text-align: left;
          }
          th.el-table-column--selection >.cell {
            text-align: center;
          }
    }
    .content {
        width: 100%;
        min-height: calc(100vh - 126px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 26px;
        box-sizing: border-box;
        padding-bottom: 16px;
        border-bottom: 32px solid #F5FAF9;
        border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;

        .data-title {
            width: 100%;
            height: 32px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-line {
                width: 2px;
                height: 16px;
                background: #00B498;
                border-radius: 0px 0px 0px 0px;
                margin-top: 8px;
            }

            .title-name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 16px;
                color: #2F3030;
                margin-left: 4px;
                line-height: 32px;
            }

            .title-btn {
                display: flex;

                .title-btn-item {
                    min-width: 92px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #E3E6E5;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-left: 8px;
                    padding-right: 8px;
                    box-sizing: border-box;
                    cursor: pointer;

                    .btn-l {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #2F3030;

                    }
                }


            }
        }
    }


}

.main {
    position: relative;
    // padding-top: 24px;
    // height: 100%;
    box-sizing: border-box;
    padding-left: 24px;
    padding-right: 24px;

    .split-line {
        // width: 1380px;
        height: 1px;
        background: #EDF2F2;
        border-radius: 0px 0px 0px 0px;
        margin-top: 14px;
    }

    .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-top: 32px;
    }

    .content-h {
        width: 100%;
        height: 124px;
        background: #F8FAFA;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        box-sizing: border-box;

        .content-h-l {

            display: flex;
            justify-content: space-between;
            align-items: center;

            .content-h-l-c {
                margin-left: 12px;

                .name {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 20px;
                    color: #2F3030;
                    line-height: 28px;
                    text-align: left;
                }

                .sex-m {
                    width: 20px;
                    height: 20px;
                    background: #E4F7F4;
                    border-radius: 2px 2px 2px 2px;
                    text-align: center;
                    color: rgba(45, 93, 207, 1);
                    margin-top: 4px;
                    margin-left: 6px;
                }

                .sex-w {
                    width: 20px;
                    height: 20px;
                    border-radius: 2px 2px 2px 2px;
                    text-align: center;
                    background: #FFE8EC;
                    margin-top: 4px;
                    margin-left: 6px;
                    color: rgba(226, 60, 88, 1)
                }

                .status {
                    width: 54px;
                    height: 24px;
                    background: #E4F7F4;
                    border-radius: 2px 2px 2px 2px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #00B498;
                    line-height: 24px;
                    text-align: center;
                    margin-top: 2px;
                    margin-left: 22px
                }

                .text {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #2F3030;
                    margin-right: 40px;
                }
            }
        }

        .content-h-r {
            .time {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #939696;
                line-height: 0px;
                text-align: right;
                margin-top: -30px;
            }
        }
    }

    .content-c {
        margin-top: 30px;

        .l-form {
            color: #2F3030;

            .el-form-item {
                // width: 290px;
                width: 25%;
                margin-right: 0;
            }

            /deep/.el-form-item__label {
                color: #939696;
            }
        }

        .text-f {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #2F3030;
            line-height: 32px;
        }

        .relative {
            width: 100%;
            height: 52px;
            background: #F8FAFA;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .sort-index {
            width: 16px;
            height: 16px;
            background: #E4F7F4;
            line-height: 16px;
            border-radius: 50%;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 12px;
            color: #00B498;
            text-align: center;
        }

        .sort-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 14px;
            color: #2F3030;
            margin-left: 2px;
        }
    }

    .main-content {
        margin-top: 30px;

    }

    .back {
        // width: 1436px;
        height: 68px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: fixed;
        left: 25%;
        right: 0;
        bottom: 0;
        border-top: 1px solid #EDF2F2;

        .back-btn {
            width: 88px;
            height: 36px;
            background: #EDF2F2;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #939696;
            line-height: 36px;
            text-align: center;
            margin-left: 24px;

        }
    }

}

.custom-tabs2 {
    /deep/ .el-tabs__item {
        width: auto;
        padding: 0 12px;
    }
}
.btn{
    font-size: 14px;
    color: #00B498;
    width: 40px;
    height: 24px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #00B498;
}
</style>
